import { AccessDeniedPage, useHasAccess } from '@carboncopyco/components';
import {
  useGetWorkspaceQuery,
  useGetWorkspacesQuery,
} from '@carboncopyco/data';
import { useWorkspaceAnalytics } from '@carboncopyco/utils';
import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import WorkspaceLayout from '../../components/Workspaces/WorkspaceLayout';
import { useUser, useWorkspaces } from '../../store/context';
import { SidebarContentType } from '../../types/WorkspacesTypes';

export const WorkspaceGate = () => {
  const { activeWorkspace, switchWorkspace } = useWorkspaces();
  const navigate = useNavigate();
  const { hasWorkspaceAccess } = useHasAccess();
  const { activeOrganization } = useUser();
  const { isFetching: isFetchingWorkspaces } = useGetWorkspacesQuery({
    organizationId: String(activeOrganization.id),
  });
  const { isFetching } = useGetWorkspaceQuery(
    {
      organizationId: String(activeOrganization.id),
      id: String(activeWorkspace.current.id),
    },
    { skip: !activeWorkspace.current.id }
  );
  const { trackWorkspaceNoAccess } = useWorkspaceAnalytics('no access page');

  useEffect(() => {
    if (!hasWorkspaceAccess) {
      trackWorkspaceNoAccess({
        workspaceId: activeWorkspace.current.id,
      });
    }
  }, []);

  if (hasWorkspaceAccess === false && !isFetchingWorkspaces && !isFetching) {
    return (
      <WorkspaceLayout>
        <AccessDeniedPage
          access="workspace"
          action={() => {
            navigate(`/${activeOrganization.id}`);
            switchWorkspace(null, SidebarContentType.Home);
          }}
        />
      </WorkspaceLayout>
    );
  }

  return <Outlet />;
};
